var map = {
	"./man.png": "H11n",
	"./woman.png": "kPgk"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "QIFE";


//////////////////
// WEBPACK FOOTER
// ./src/assets/account ^\.\/.*\.png$
// module id = QIFE
// module chunks = 38